import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";

const PatientHistory = ({ selectedPatient }) => {
  const [background, setBackground] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    if (!selectedPatient) return;

    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", selectedPatient.id);

    const unsubscribe = onSnapshot(
      patientRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setBackground(data.background || {});
        } else {
          setBackground({});
        }
      },
      (error) => {
        setError("Ocurrió un error al cargar los antecedentes.");
      }
    );

    return () => unsubscribe();
  }, [selectedPatient]);

  return (
    <div className="dataHistory">
      {error && <p style={{ color: "red" }}>{error}</p>}

      {background && Object.keys(background).length > 0 ? (
        <ul className="dataList">
          {Object.entries(background).map(([key, value], index) => (
            <li key={index} className="dataItem">
              <strong>{key}:</strong> {value}
            </li>
          ))}
        </ul>
      ) : (
        <p>Todavía no hay antecedentes registrados.</p>
      )}
    </div>
  );
};

export default PatientHistory;
